import { Box } from "@mui/material";
import {
  renderLink,
  renderRelativeTimeWithTooltip,
} from "components/DataTable/renderComponents";
import Severity from "components/Severity";
import { DataTable } from "empower-energy-owner-components";
import OwnerNotificationModal from "./OwnerNotificationModal";
import { useState } from "react";
import { isNil } from "lodash";
import SiteName from "components/Site/SiteName";

const OwnerNotificationList = ({ loading, list = [], source = "unit" }) => {
  const [notification, setNotification] = useState(null);

  const getColumns = () => {
    const columns = [
      {
        field: "title",
        headerName: "Title",
        minWidth: 200,
        flex: 1,
        renderCell: (params) =>
          renderLink(params, params.value, (item) => setNotification(item)),
      },
      {
        field: "name",
        headerName: "Message (Active)",
        minWidth: 200,
      },
      {
        field: "resolved_name",
        headerName: "Message (Resolved)",
        minWidth: 200,
      },
      {
        field: "severity",
        headerName: "Severity",
        width: 120,
        renderCell: (params) => <Severity severity={params.value} />,
      },
      {
        field: "timestamp",
        headerName: "Timestamp",
        width: 120,
        renderCell: (params) =>
          renderRelativeTimeWithTooltip(params.value * 1000),
      },
      {
        field: "resolved",
        headerName: "Resolved",
        width: 120,
        renderCell: (params) =>
          renderRelativeTimeWithTooltip(params.value * 1000),
      },
      {
        field: "acknowledged",
        headerName: "Acknowledged",
        width: 120,
        renderCell: (params) =>
          renderRelativeTimeWithTooltip(params.value * 1000),
      },
      {
        field: "deleted",
        headerName: "Deleted",
        width: 120,
        renderCell: (params) =>
          renderRelativeTimeWithTooltip(params.value * 1000),
      },
    ];

    if (source === "global") {
      columns.unshift({
        field: "site",
        headerName: "Site",
        width: 240,
        renderCell: (params) => <SiteName id={params.value} />,
      });
    }

    return columns;
  };

  return (
    <Box>
      <DataTable rows={list} columns={getColumns()} loading={loading} />
      {!isNil(notification) && (
        <OwnerNotificationModal
          open={true}
          onClose={() => setNotification(null)}
          id={notification.id}
          siteId={notification?.site}
        />
      )}
    </Box>
  );
};

export default OwnerNotificationList;
